module.exports = __webpack_public_path__ + "static/visual_3_3_eg-ed831b2f5fbdca38879dfb2d4ba18fbd.png";